import * as actionTypes from '../constants';

export const updateInProducts = payload => ({
  type: actionTypes.ACTION_UPDATE_INPRODUCTS,
  payload,
});

export const updateApaveProducts = payload => ({
  type: actionTypes.ACTION_UPDATE_APAVEPRODUCTS,
  payload,
});

export const updateBookmarkProducts = payload => ({
  type: actionTypes.ACTION_UPDATE_BOOKMARKPRODUCTS,
  payload,
});
